export const dailyPickingCapacityByAttribute = {
    searchText: 'Buscar categorias',
    export: false,
    filter: false,
    checkbox: true,
    show: 'Aun no hay capacidades que mostrar',
    iconsOfActions: [
        {
            icon: 'cancel',
            tooltip: 'Eliminar capacidad'
        }, 
        {
            icon: 'edit', 
            tooltip: 'Editar capacidad',
            hasVisibleCondition: (element: any[]): boolean => {
                return element && element.length && element.length <= 1 ? true : false;
            }
        },
        {
            icon: 'exception-days', 
            tooltip: 'Agregar excepción'
        },
        {
            icon: 'calendar', 
            tooltip: 'Agregar excepción de feriados'
          }
    ],
    columns: [
        {
            title: 'Atributo',
            name: 'attribute',
            type: 'string',
            class: 'left',
            value: (element: any) => element.attribute? element.attribute.category:''
        },
        {
            title: 'Nº Unidades',
            name: 'capacityValue',
            type: 'string',
            class: 'left',
            value: (element: any) => element.capacityValue
        },
        {
            title: 'Códigos Vtex',
            name: 'vtexCodeList',
            type: 'string',
            class: 'left',
            value: (element: any) => element.vtexCodeList && element.vtexCodeList.length > 0 ? element.vtexCodeList.map((item) => item.vtexCode): ''
        },
        {
            title: 'Tiene excepciones',
            name: 'exception',
            type: 'string',
            class: 'left',
            value: (element: any) => element.capacityException && element.capacityException.length > 0 ? 'SI': 'NO'
        }
    ]
};
